import React from 'react';
import { useAppConfigQuery } from '../../hooks/query/useAppConfigQuery';

export type GeoblockCheckProps = (props: { isBlocked: boolean }) => React.ReactNode;

export const GeoblockCheck: React.FC<{
    children: React.ReactNode;
    renderWhenBlocked: GeoblockCheckProps;
}> = ({ children, renderWhenBlocked }) => {
    const { appSettings } = useAppConfigQuery();
    const isBlocked =
        appSettings?.features?.geoblock?.enabled &&
        appSettings?.features?.geoblock?.global?.blocked;

    if (isBlocked) {
        return <>{renderWhenBlocked({ isBlocked })}</>;
    }

    return <>{children}</>;
};
